import { Box, Grid, IconButton, List, ListItem, ListItemIcon, SxProps, Theme, Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { howToTextsC, IsLeo, IsVideo, themeC } from "../theme/themehelper";
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import image from '../images/stadium.jpg';
import orangeStadium from '../images/expekt_background.png';
import gogoStadium from '../images/gogo_background.jpg';
import woodLanding from '../images/wood_landing.png';
import leoLanding from '../images/lion_landing.png';
import kungImage from '../images/kung_landing.png';
import kungBet from '../images/kung_people.png';
import kungFollow from '../images/follow_kung.png';
import kungWin from '../images/win_kung.png';
import mrVegasBet from '../images/mrVegas_bet.png';
import mrVegasFollow from '../images/mrVegas_follow.png';
import mrVegasWin from '../images/mrVegas_win.png';
import megaBet from '../images/mega_bet.png';
import megaFollow from '../images/mega_follow.png';
import megaWin from '../images/mega_win.png';
import dbetImage from '../images/dbet_landing.jpeg';
import videoImage from '../images/video_landing.png';
import mrVegasImage from '../images/mrvegas_background.jpeg';
import megaImage from '../images/mega_background.jpeg';
import dBetFollow from '../images/follow_dbet.png';
import unibetLanding from '../images/unibet_landing.jpg';
import unibetRiple from '../images/unibet_riple.png';
import comeonBackground from '../images/comeon_background.png';
import hajperBackground from '../images/hajper_background.png';
import snabbareBackground from '../images/snabbare_background.png';
import reviantBackground from '../images/reviant_background.jpeg';
import lylloBackground from '../images/lyllo_background.png';
import stuganBackground from '../images/background_stugan.png';
import kryssBackground from '../images/kryss_landing.jpeg';
import hardBackground from '../images/hard_background.png';
import hardBet from '../images/hard_bet.png';
import hardFollow from '../images/hard_follow.png';
import hardWin from '../images/hard_win.png';
import hajperBet from '../images/hajper_bet.png';
import hajperFollow from '../images/hajper_follow.png';
import hajperWin from '../images/hajper_win.png';
import hajperLogo from '../images/hajper_logo.png';
import { Unibet1x2Logo, UnibetBetIcon, UnibetFollowIcon, UnibetWinIcon } from '../images/unibeticons';

const BANNER_DISMISSED_KEY = 'landing_banner_dismissed';

function LandingInfoBox({ theme }: { theme: string }) {
    const { t } = useTranslation();
    const [dismissed, setDismissed] = useState(() => localStorage.getItem(BANNER_DISMISSED_KEY) === 'true');
    
    if (dismissed) {
        return null;
    }

    const handleClose = () => {
        localStorage.setItem(BANNER_DISMISSED_KEY, 'true');
        setDismissed(true);
    };

    let backgroundHeight = "376px";

    let betFollowWin: SxProps<Theme> = {
        fontFamily: "var(--font-title)",
        fontSize: "var(--font-title-size)",
        letterSpacing: "var(--font-title-letter-spacing)",
        lineHeight: "30px",
        fontWeight: "var(--font-title-weight)",
        margin: 0,
        textTransform: "uppercase"
    };

    let boxInPicture: SxProps<Theme> = {
        marginLeft: "10px",
        marginRight: "10px",
        position: "relative",
        width: "auto",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2,
        "::before": {
            content: '""',
            opacity: 0.7,
            background: 'var(--title-bar-background)',
            position: 'absolute',
            top: '0px',
            right: '0px',
            bottom: '0px',
            left: '0px',
            borderRadius: 'var(--radius)'
        }
    }

    let marginLeft = "0px";
    let text = 'white';
    let iconColor = 'white';
    let betIcon = `url(${kungBet})`;
    let followIcon = `url(${kungFollow})`;
    let winIcon = `url(${kungWin})`;
    let iconWidthBet = "40px";
    let iconHeightBet = "40px";
    let iconWidthFollow = "40px";
    let iconHeightFollow = "40px";
    let iconWidthWin = "40px";
    let iconHeightWin = "40px";
    let backgroundImage = `url(${image})`;
    let bgSize = "cover";
    let bgPosition = "center center";
    let borderColor = "";
    let dbetTitle = betFollowWin;
    let useCustomIcon = false;

    let betTitle = t('bet_title');
    let betText = t('bet_text');
    let followTitle = t('follow_title');
    let followText = t('follow_text');
    let winTitle = t('win_title');
    let winText = t('win_text');

    let betFollowWinText: SxProps<Theme> = {
        display: 'inline',
        fontFamily: "var(--font-body)",
    }

    if (theme === themeC.Dbet) {
        betFollowWin.fontFamily = "Righteous";
        betFollowWin.fontSize = "14px";
        betFollowWin.fontWeight = 400;
        betFollowWin.lineHeight = "17.38px";
        betFollowWin.textTransform = "none";
        backgroundImage = `url(${dbetImage})`;
        borderColor = "#F4C004";
        dbetTitle = { ...betFollowWin, fontSize: 20, marginTop: "10px", marginBottom: "10px", position: "relative", zIndex: 3 };
        followIcon = `url(${dBetFollow})`;
    }

    if (IsVideo(theme)) {
        betTitle = howToTextsC.Dbet.bet_title;
        betText = howToTextsC.Dbet.bet_text;
        followTitle = howToTextsC.Dbet.follow_title;
        followText = howToTextsC.Dbet.follow_text;
        winTitle = howToTextsC.Dbet.win_title;
        winText = howToTextsC.Dbet.win_text;
        useCustomIcon = true;
    }

    if (theme === themeC.Video || theme === themeC.MrVegas || theme === themeC.Mega) {
        betFollowWin.fontSize = "12px";
        betFollowWin.fontWeight = 700;
    }

    if (IsLeo(theme)) {
        marginLeft = "-20px";
        backgroundHeight = "260px";
        betFollowWin.fontSize = "16px";
        betFollowWin.fontWeight = 700;
        betFollowWin.lineHeight = "19px";
        betFollowWinText = {
            display: 'inline',
            fontSize: "12px",
            lineHeight: "14px",
            fontFamily: "var(--font-body)"
        };
        (boxInPicture['::before'] as any).background = "#18192D";
    }

    if (theme === themeC.ComeOn) {       
        betFollowWin.fontFamily = "Gravity";
        backgroundHeight = "310px";
        betFollowWin.fontSize = "22px";
        betFollowWin.fontWeight = 400;
        betFollowWin.textTransform = 'None';
        text = "#F9F9F9";
        iconColor = "#C0F9C8";
        (boxInPicture['::before'] as any).background = "#222222";
        backgroundImage = `url(${comeonBackground})`;
    }

    if (theme === themeC.Hajper) {
        betFollowWin.fontFamily = 'HajperSansMedium';
        betFollowWin.textTransform = 'None';
        betFollowWin.fontWeight = 500;
        betFollowWin.fontSize = "9.62px";
        betFollowWinText.fontFamily = 'HajperSansMedium';
        betFollowWinText.fontSize = "12.83px";
        betFollowWinText.fontWeight = 500;
        betFollowWinText.fontStyle = 'italic';
        (boxInPicture['::before'] as any).background = "#16219a7d";
        (boxInPicture['::before'] as any).border = "solid 2px #373cf175";
        (boxInPicture['::before'] as any).borderRadius = "25px";
        (boxInPicture['::before'] as any).WebkitBackdropFilter = 'blur(5px)';
        (boxInPicture['::before'] as any).backdropFilter = "blur(5px)";
        backgroundImage = `url(${hajperBackground})`;
        betTitle = howToTextsC.Hajper.bet_title;
        betText = howToTextsC.Hajper.bet_text;
        followTitle = howToTextsC.Hajper.follow_title;
        followText = howToTextsC.Hajper.follow_text;
        winTitle = howToTextsC.Hajper.win_title;
        winText = howToTextsC.Hajper.win_text;
        betIcon = `url(${hajperBet})`;
        followIcon = `url(${hajperFollow})`;
        winIcon = `url(${hajperWin})`;
        iconWidthBet = "20px";
        iconHeightBet = "20px";
        iconWidthFollow = "23px";
        iconHeightFollow = "30px";
        iconWidthWin = "25px";
        iconHeightWin = "24px";
        useCustomIcon = true;
    }

    if (theme === themeC.Snabbare || theme === themeC.Reviant) {
        betFollowWin.fontWeight = 700;
        betFollowWin.textTransform = "none";
        betFollowWin.fontStyle = "italic";
        (boxInPicture['::before'] as any).background = theme === themeC.Reviant ? "#E71F00E5" : "#0086FFE5";
        backgroundImage = theme === themeC.Reviant
            ? `url(${reviantBackground})`
            : `url(${snabbareBackground})`;
        const texts = theme === themeC.Reviant ? howToTextsC.Reviant : howToTextsC.Snabbare;
        betTitle = texts.bet_title;
        betText = texts.bet_text;
        followTitle = texts.follow_title;
        followText = texts.follow_text;
        winTitle = texts.win_title;
        winText = texts.win_text;
    }

    if (theme === themeC.Lyllo) {
        betFollowWin.fontSize = "14px";
        betFollowWin.fontWeight = 700;
        (boxInPicture['::before'] as any).background = "#F02884";
        backgroundImage = `url(${lylloBackground})`;
        betTitle = howToTextsC.Lyllo.bet_title;
        betText = howToTextsC.Lyllo.bet_text;
        followTitle = howToTextsC.Lyllo.follow_title;
        followText = howToTextsC.Lyllo.follow_text;
        winTitle = howToTextsC.Lyllo.win_title;
        winText = howToTextsC.Lyllo.win_text;
    }

    if (theme === themeC.Stugan) {
        betFollowWin.fontSize = "14px";
        betFollowWin.fontWeight = 700;
        betFollowWin.textTransform = "none";
        (boxInPicture['::before'] as any).background = "#282B33CC";
        backgroundImage = `url(${stuganBackground})`;
        betTitle = howToTextsC.Stugan.bet_title;
        betText = howToTextsC.Stugan.bet_text;
        followTitle = howToTextsC.Stugan.follow_title;
        followText = howToTextsC.Stugan.follow_text;
        winTitle = howToTextsC.Stugan.win_title;
        winText = howToTextsC.Stugan.win_text;
    }

    if (theme === themeC.Kryss) {
        betFollowWin.fontFamily = "Fugaz One";
        betFollowWin.fontSize = "16px";
        betFollowWin.fontWeight = 700;
        betFollowWin.textTransform = "uppercase";
        (boxInPicture['::before'] as any).background = "#282B33CC";
        backgroundImage = `url(${kryssBackground})`;
    }

    if (theme === themeC.Hard) {
        betFollowWin.fontFamily = "var(--font-title)";
        betFollowWin.fontSize = "16px";
        betFollowWin.fontWeight = 900;
        betFollowWin.textTransform = "none";
        betFollowWin.marginBottom = "5px";
        betFollowWin.color = "var(--button-color)";
        betFollowWinText.fontFamily = "var(--font-body)";
        betFollowWinText.fontSize = "14px";
        betFollowWinText.fontWeight = 400;       

        (boxInPicture['::before'] as any).background = "linear-gradient(0deg, rgba(21, 21, 21, 0.5), rgba(21, 21, 21, 0.5)),linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%)";
        backgroundImage = `url(${hardBackground})`;

        betIcon = `url(${hardBet})`;
        followIcon = `url(${hardFollow})`;
        winIcon = `url(${hardWin})`;
        iconWidthBet = "24px";
        iconHeightBet = "24px";
        iconWidthFollow = "24px";
        iconHeightFollow = "24px";
        iconWidthWin = "24px";
        iconHeightWin = "24px";
        useCustomIcon = true;

        betTitle = howToTextsC.Hard.bet_title;
        betText = howToTextsC.Hard.bet_text;
        followTitle = howToTextsC.Hard.follow_title;
        followText = howToTextsC.Hard.follow_text;
        winTitle = howToTextsC.Hard.win_title;
        winText = howToTextsC.Hard.win_text;
    }

    if (theme === themeC.Green) {
        (boxInPicture['::before'] as any).background = "rgba(17, 17, 17, 0.85)";
        (boxInPicture['::before'] as any).opacity = 1;
        (boxInPicture['::before'] as any).borderRadius = "4px";
        boxInPicture.padding = "16px";
        boxInPicture.paddingRight = "100px";
        boxInPicture.gap = "10px";
        boxInPicture.zIndex = 2;
        backgroundImage = `url(${unibetLanding})`;
        bgSize = "200%";
        bgPosition = "center 52%";
        useCustomIcon = true;
        betIcon = 'unibetBet';
        iconWidthBet = "16px";
        iconHeightBet = "16px";
        followIcon = 'unibetFollow';
        iconWidthFollow = "16px";
        iconHeightFollow = "16px";
        winIcon = 'unibetWin';
        iconWidthWin = "16px";
        iconHeightWin = "16px";
        betFollowWin = {
            fontFamily: "UnibetPro",
            fontWeight: 500,
            fontSize: "18px",
            lineHeight: "20px",
            color: "#FFFFFF",
            margin: 0,
            textTransform: "none",
        };
        betFollowWinText = {
            fontFamily: "'Roboto'",
            fontWeight: 400,
            fontSize: "12px",
            lineHeight: "16px",
            color: "#FFFFFF",
            display: "inline",
            textTransform: "none",
        };
        betTitle = "Unibet 1X2";
        betText = "Välj 1, X eller 2 i varje match";
        followTitle = "Live-bevakning";
        followText = "Följ dina matcher och se vinstchanserna live";
        winTitle = "Högre utdelning";
        winText = "80 % tillbaka till spelarna – mer än många traditionella poolspel";
    }

    if (theme === themeC.Orange) {
        backgroundImage = `url(${orangeStadium})`;
    }

    if (theme === themeC.GoGo) {
        backgroundImage = `url(${gogoStadium})`;
    }

    if (theme === themeC.Wood) {
        backgroundImage = `url(${woodLanding})`;
    }

    if (theme === themeC.Lion) {
        backgroundImage = `url(${leoLanding})`;
    }

    if (theme === themeC.Kung) {
        backgroundImage = `url(${kungImage})`;
        borderColor = "#249CEC";
        dbetTitle = { ...betFollowWin, fontSize: 20, marginTop: "0px", marginBottom: "0px", position: "relative", zIndex: 3 };
    }

    if (theme === themeC.Video) {
        backgroundImage = `url(${videoImage})`;
        borderColor = "#F4C004";
        dbetTitle = { ...betFollowWin, fontSize: 14, marginTop: "0px", marginBottom: "0px", position: "relative", zIndex: 3 };
    }

    if (theme === themeC.MrVegas) {
        backgroundImage = `url(${mrVegasImage})`;
        borderColor = "#F4C004";
        dbetTitle = { ...betFollowWin, fontSize: 14, marginTop: "0px", marginBottom: "0px", position: "relative", zIndex: 3 };
    }

    if (theme === themeC.Mega) {
        backgroundImage = `url(${megaImage})`;
        borderColor = "#B89A54";
        dbetTitle = { ...betFollowWin, fontSize: 14, marginTop: "0px", marginBottom: "0px", position: "relative", zIndex: 3 };
    }    

    if (theme === themeC.MrVegas) {
        betIcon = `url(${mrVegasBet})`;
        followIcon = `url(${mrVegasFollow})`;
        winIcon = `url(${mrVegasWin})`;
        iconWidthBet = "38px";
        iconHeightBet = "44px";
        iconWidthFollow = "38px";
        iconHeightFollow = "44px";
        iconWidthWin = "38px";
        iconHeightWin = "44px";
    }

    if (theme === themeC.Mega) {
        betIcon = `url(${megaBet})`;
        followIcon = `url(${megaFollow})`;
        winIcon = `url(${megaWin})`;
        iconWidthBet = "38px";
        iconHeightBet = "44px";
        iconWidthFollow = "38px";
        iconHeightFollow = "44px";
        iconWidthWin = "38px";
        iconHeightWin = "44px";
    }


    return (

        <Grid container sx={{
            width: "100%",
            height: backgroundHeight,
            backgroundImage: backgroundImage,
            justifyContent: "center",
            alignItems: "center",
            backgroundPosition: bgPosition,
            backgroundSize: bgSize,
            position: "relative"
        }}>
            {theme === themeC.Green &&
                <Box sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: "linear-gradient(270deg, rgba(0, 0, 0, 0.45) 0%, rgba(0, 125, 63, 0.3) 100%)",
                    zIndex: 1,
                }} />
            }
            {theme === themeC.Green &&
                <Box sx={{
                    backgroundImage: `url(${unibetRiple})`,
                    width: "200px",
                    height: "140px",
                    backgroundSize: "contain",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "bottom right",
                    position: "absolute",
                    bottom: 0,
                    right: 0,
                    zIndex: 1,
                }} />
            }

            <Grid container justifyContent="center">
                <Grid item sm={6} height="100%">
                    <Grid container direction="column" alignItems="center"
                        sx={{ ...boxInPicture, position: 'relative' }}
                    >
                        {theme !== themeC.Green && <IconButton
                            onClick={handleClose}
                            sx={{
                                position: 'absolute',
                                top: 4,
                                right: 4,
                                zIndex: 4,
                                color: text,
                                padding: '4px',
                            }}
                            aria-label="close banner"
                        >
                            <CloseIcon fontSize="small" />
                        </IconButton>}
                        {theme === themeC.Green &&
                            <Box sx={{
                                position: "absolute",
                                top: 10,
                                right: 10,
                                zIndex: 2,
                            }}>
                                <Unibet1x2Logo width={79} height={40} />
                            </Box>
                        }
                        {IsVideo(theme) &&
                            <Typography color={text}
                                className='list-item'
                                sx={dbetTitle}>Varför Supertipset är bättre</Typography>
                        }
                        {theme === themeC.Hajper &&
                            <Grid container>
                                <Box sx={{
                                    backgroundImage: `url(${hajperLogo})`,
                                    width: "100px", height: "100px", backgroundSize: "contain",
                                    backgroundRepeat: "no-repeat",
                                    position: "relative",
                                    marginBottom: "-50px",
                                    zIndex: 1,
                                }} />
                            </Grid>
                        }
                        <List sx={{ color: text }} className='list-item'>
                            <ListItem disablePadding>
                                <ListItemIcon>
                                    {betIcon === 'unibetBet' ? <UnibetBetIcon width={Number(iconWidthBet.replace('px',''))} height={Number(iconHeightBet.replace('px',''))} /> :
                                        useCustomIcon ? <Box sx={{ backgroundImage: betIcon, width: iconWidthBet, height: iconHeightBet, backgroundSize: "contain", backgroundRepeat: "no-repeat" }} /> :
                                        <TaskAltIcon sx={{ color: iconColor }} />}
                                </ListItemIcon>
                                <Grid container direction="column" sx={{ color: text, marginLeft: { marginLeft }, marginTop: "5px", marginBottom: "5px" }}>
                                    <Typography
                                        color={text}
                                        className='bet-follow-win'
                                        sx={betFollowWin}
                                    >
                                        {betTitle}
                                    </Typography>
                                    <Typography
                                        sx={betFollowWinText}
                                        component="span"
                                        variant="body2"
                                        color={text}
                                    >
                                        {betText}
                                    </Typography>
                                </Grid>
                            </ListItem>

                            {(IsVideo(theme)) &&
                                <ListItem>
                                    <Grid container direction="row" justifyContent="center" sx={{ marginTop: "10px" }}>
                                        <Box sx={{ border: "2px solid " + borderColor, width: "18px", height: "0px" }} />
                                    </Grid>
                                </ListItem>
                            }
                            <ListItem disablePadding>
                                <ListItemIcon>
                                    {followIcon === 'unibetFollow' ? <UnibetFollowIcon width={Number(iconWidthFollow.replace('px',''))} height={Number(iconHeightFollow.replace('px',''))} /> :
                                        useCustomIcon ? <Box sx={{ backgroundImage: followIcon, width: iconWidthFollow, height: iconHeightFollow, backgroundSize: "contain", backgroundRepeat: "no-repeat" }} /> :
                                        <SportsSoccerIcon sx={{ color: iconColor }} />}
                                </ListItemIcon>
                                <Grid container direction="column" sx={{ color: text, marginTop: "5px", marginBottom: "5px", marginLeft: { marginLeft } }}>
                                    <Typography
                                        color={text}
                                        className='bet-follow-win'
                                        sx={betFollowWin}
                                    >
                                        {followTitle}
                                    </Typography>

                                    <Typography
                                        sx={betFollowWinText}
                                        component="span"
                                        variant="body2"
                                        color={text}
                                    >
                                        {followText}
                                    </Typography>

                                </Grid>
                            </ListItem>
                            {IsVideo(theme) &&
                                <ListItem>
                                    <Grid container direction="row" justifyContent="center" sx={{ marginTop: "10px" }}>
                                        <Box sx={{ border: "2px solid " + borderColor, width: "18px", height: "0px" }} />
                                    </Grid>
                                </ListItem>
                            }
                            <ListItem disablePadding>
                                <ListItemIcon>
                                    {winIcon === 'unibetWin' ? <UnibetWinIcon width={Number(iconWidthWin.replace('px',''))} height={Number(iconHeightWin.replace('px',''))} /> :
                                        useCustomIcon ? <Box sx={{ backgroundImage: winIcon, width: iconWidthWin, height: iconHeightWin, backgroundSize: "contain", backgroundRepeat: "no-repeat" }} /> :
                                        <EmojiEventsIcon sx={{ color: iconColor }} />}
                                </ListItemIcon>
                                <Grid container direction="column" sx={{ color: text, marginTop: "5px", marginBottom: "5px", marginLeft: { marginLeft } }}>

                                    <Typography
                                        color={text}
                                        className='bet-follow-win'
                                        sx={betFollowWin}
                                    >
                                        {winTitle}
                                    </Typography>

                                    <Typography
                                        sx={betFollowWinText}
                                        component="span"
                                        variant="body2"
                                        color={text}
                                    >
                                        {winText}
                                    </Typography>

                                </Grid>
                            </ListItem>
                        </List>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );

}
export default LandingInfoBox;